import jwtDecode from "jwt-decode";
import { getToken } from "./utils/localStorage";

export enum API_ROUTES {
  USER = "user",
  MED_DATA = "med-data",
  VIRTUAL_DOC = "virtual-doc",
  COMMUNICATION = "communication",
}

export enum VERSIONS {
  v1 = "v1",
  v2 = "v2",
}
export function getVersion(ms: API_ROUTES, version: VERSIONS): string {
  return `${ms}/${version}`;
}

export function isFederatedUser() {
  const authToken = getToken("VERIS_ACCESS_TOKEN");
  const decoded = jwtDecode(authToken ?? "") as { isFederatedUser: boolean };
  return decoded.isFederatedUser;
}
